/* eslint-disable @typescript-eslint/naming-convention */
import { Component, createMemo, JSXElement } from 'solid-js';
import { BtnClasses } from '../../types/common';
import Icon from '../Icon/Icon';
import type { IconSize } from '../Icon/icon-size';

export type IconShape = 'icon-circle' | 'icon-square';
export interface IconButtonProps {
  icon: string;
  clicked?(event: MouseEvent): void;
  size?: IconSize;
  color?: BtnClasses;
  shape?: IconShape;
  title?: string;
  disabled?: boolean;
  'data-cy'?: string;
  /** Additional classes to apply to the <button/> element */
  buttonClasses?: string;
  /** Additional classes to apply to the <Icon /> element */
  classes?: string;
}

const IconButton: Component<IconButtonProps> = (props): JSXElement => {
  const disableTooltip = createMemo(
    () => props.title == null || props.title.trim().length === 0
  );

  const buttonClasses = createMemo(() => {
    return [
      'button',
      props.size || 'icon-medium',
      props.color || 'tertiary',
      props.shape || 'icon-circle',
      props.buttonClasses ?? '',
    ];
  });

  return (
    <modus-wc-tooltip
      content={props.title}
      position="bottom"
      disabled={disableTooltip()}
      class="[&_div]:flex"
    >
      <button
        class={
          buttonClasses().join(' ') +
          (props.disabled ? ' !cursor-not-allowed opacity-50' : '')
        }
        type="button"
        onClick={(event) => {
          if (!props.disabled) {
            props.clicked?.(event);
          }
        }}
        data-cy={props['data-cy'] || 'icon-button'}
        data-testid={props['data-cy'] || 'icon-button'}
        disabled={props.disabled}
        data-icon={props.icon} // Add attribute to avoid using shadow DOM in tests
      >
        <Icon icon={props.icon} size={props.size} class={props.classes} />
      </button>
    </modus-wc-tooltip>
  );
};

export default IconButton;
